module.exports = __webpack_public_path__ + "static/73bc711534bdebbe4ccc81dda71b5d82e2b9883c6cedbd5caf9d955c64f476ec-32d843b180087a4b6f9c6340d99f86ad.jpeg";